import React, { useEffect, useState, useRef, useMemo } from 'react';
import YarnTypeService from '../../services/yarn-type.service';
import './yarn-type-list.scss';
import {
  GridComponent,
  Inject,
  Toolbar,
  ToolbarItems,
  Edit,
  EditSettingsModel,
  Page,
  Sort,
  PdfExport,
  PdfExportProperties,
  ExcelExport,
  Grid,
  Resize,
  FilterSettingsModel,
  Filter,
  Group,
  GroupSettingsModel,
  AggregateColumnDirective,
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  Freeze,
  ColumnChooser,
  Reorder,
  DialogEditEventArgs,
  CommandColumn,
  CommandModel,
} from '@syncfusion/ej2-react-grids';
import { ClickEventArgs } from '@syncfusion/ej2-react-navigations';
import YarnTypeAdd from './yarn-type-add';
import YarnTypeEdit from './yarn-type-edit'
// import YarnPurchaseContractEdit from './yarn-purchase-contract-edit';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
// import YarnContractDeliveryScheduleList from '../yarn-contract-delivery-schedule/yarn-contract-delivery-schedule-list';
import moment from 'moment';
import SecurityService from '../security/security.service';
// import { useMemo } from 'react';
import AuditTableInput from '../audit-table/audit-table';
import HardDelete from '../hard-delete/hard-delete';

let selectedRows = []

export default function YarnTypeList(props) {
  const [yarnTypes, setYarnTypes] = useState([]);
  // const [showDialog, setShowDialog] = useState(false);
  // const [selectedRow, setSelectedRow] = useState({});

  const [deleteDialogVisibility, setDeleteDialogVisibility] = useState(false);
  const [dialogWarningVisibility, setDialogWarningVisibility] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const deleteDialog = useRef();
  const warningDialog = useRef();
  const [showDialogs, setShowDialogs] = useState();
  const [deletingProps, setDeletingProps] = useState();

  const [deletingID, setDeletingID] = useState(0);
  // let deletingID = 0;

  let yarnTypesGrid: Grid;

  const toolbarClick = (args: ClickEventArgs) => {
    console.log('args.item.properties :', args.item.properties);
    if (
      yarnTypesGrid &&
      args.item.properties.id === 'yarnTypesGrid_PDFExport'
    ) {
      const exportProperties: PdfExportProperties = {
        pageOrientation: 'Landscape',
        fileName: `${moment().format('YYYYMMDD')}_yarn_type.pdf`
      };
      console.log('clicked on pdf export');
      yarnTypesGrid.pdfExport(exportProperties);
    }
    if (
      yarnTypesGrid &&
      args.item.properties.id === 'yarnTypesGrid_excelexport'
    ) {
      const exportProperties: PdfExportProperties = {
        fileName: `${moment().format('YYYYMMDD')}_yarn_type.xlsx`
      };
      yarnTypesGrid.excelExport(exportProperties);
    }
    if (
      yarnTypesGrid &&
      args.item.properties.id === 'yarnTypesGrid_columnchooser'
    ) {
    }

    if (yarnTypesGrid && args.item.properties.id === 'Delete') {
      console.log('toolbar Delete');
      if (yarnTypesGrid.selectedRowIndex === -1) {
        // no rows selected
        console.log('Delete ', yarnTypesGrid.getSelectedRecords()[0]);
        // setDialogWarningVisibility(false);
        let obj={
          TableName:`YarnCount`,
          ColumnName:`YarnCountID`,
          RowID:undefined,
          SelectedRow:false
          
        }
        setDeletingProps(obj)
        // setShowDialogs(true)
       
      } else {
        console.log('delete: ', yarnTypesGrid.getSelectedRecords())
        console.log(selectedRows)
        // deleteDialog.current.hide();
        let obj={
          TableName:`YarnType`,
          ColumnName:`YarnTypeID`,
          RowID:yarnTypesGrid.getSelectedRecords()[0]['YarnTypeID'],
          SelectedRow:true,
          SelectedRowData:{
            YarnType:  yarnTypesGrid.getSelectedRecords()[0].YarnType,
            YarnTypeShort: yarnTypesGrid.getSelectedRecords()[0].YarnTypeShort
          }

          
          }
          setDeletingProps(obj)
        
        // deleteDialog.current.show();
        setShowDialogs(true)
      }
    }

    // if (
    //   yarnTypesGrid &&
    //   args.item.properties.id === 'yarnTypesGrid_Delivery Schedule'
    // ) {
    //   console.log('clicked delivery');
    // }
  };

  useEffect(() => {
    // const type = getRoute()[1];
    getYarnTypes();
  }, []);

  const getYarnTypes = async () => {
    YarnTypeService.getAll()
      .then((response) => {
        console.log('get all yarn type:', response)
        setYarnTypes(response.data.recordset);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const addYarnType = () => {
    props.history.push('/YarnType/Add');
  };

  const getRoute = () =>
    window.location.pathname
      .substr(1, window.location.pathname.length)
      .split('/');

  const toolbarOptions: ToolbarItems[] = [
    'Add',
    'Edit',
    {
      text: "Delete",
      tooltipText: "Delete",
      id: "Delete",
      disabled: !SecurityService.canUserAccess('YarnTypeDelete'),
    },
    'Update',
    'Cancel',
    'PDFExport',
    'ExcelExport',
    'Search',
    'ColumnChooser',
  ];

  const databound = () =>
  {
      if (yarnTypesGrid) {
        yarnTypesGrid.autoFitColumns();
      }
  }


  const dialogTemplate = (props) => {
    console.log('props: ', props);
    return props.isAdd ?
      (
        <YarnTypeAdd dataList={yarnTypes} {...props}> </YarnTypeAdd>
      ) :
      (
        <YarnTypeEdit dataList={yarnTypes} {...props}> </YarnTypeEdit>
      );
  };

  const editSettings: EditSettingsModel = {
    allowEditing: SecurityService.canUserAccess('YarnTypeEdit'),
    allowAdding: SecurityService.canUserAccess('YarnTypeAdd'),
    allowDeleting: SecurityService.canUserAccess('YarnTypeDelete'),

    // allowEditing: true,
    // allowAdding: true,
    // allowDeleting: true,

    mode: 'Dialog',
    // showDeleteConfirmDialog: true,
    template: dialogTemplate,
  };

  const filterOptions: FilterSettingsModel = {
    type: 'Excel',
    // columns: [
    //   {
    //     field: 'IsDeleted',
    //     operator: 'notequal',
    //     value: 'True'
    //   }
    // ]
  };

  const groupOptions: GroupSettingsModel = {
    showDroopArea: true,
  };

  const sortingOptions: SortSettingsModel = {
    columns: [{ field: 'YarnTypeID', direction: 'Descending' }]
  }

  const footerSum = (e: any) => {
    return <span> Sum: {e.Sum}</span>;
  };

  const actionComplete = (args: DialogEditEventArgs) => {
    console.log('data: ', args);
    if (args?.requestType === 'columnstate') {
      console.log('adjusting column');
      yarnTypesGrid?.autoFitColumns();
    }
    if (args.form) {
      console.log('data: ', args);
      if (args.requestType === 'beginEdit' || args.requestType === 'add') {
        console.log('e: ', args.form.ej2_instances[0]);
        /** Add Validation Rules */

        args.form.ej2_instances[0].addRules('YarnType', {
          required: true,
        });

        args.form.ej2_instances[0].addRules('YarnTypeShort', {
          required: true,
        });
      }

      if (args.requestType === 'save' && args.action === 'add') {
        const data = {
          UserId: userId,
          ...args.data
        };
        console.log('data: ', data);
        YarnTypeService.create(data).then((response) => {
          console.log('add response:', response);

          let AddData = {
            YarnType: args.data.YarnType,
            YarnTypeShort: args.data.YarnTypeShort
          }
          AuditTableInput.auditAdd(`YarnType`,`YarnType`,`YarnTypeID`,AddData)

         setYarnTypes(response.data.recordset);
          // refresh grid to show new record
          // const type = getRoute()[1];
          // getYarnTypes(type);

        });
      }
      if (args.requestType === 'save' && args.action === 'edit') {
        const data = {
          UserId: userId,
          ...args.data
        };
        console.log('data: ', data);
        YarnTypeService.update( args.data.YarnTypeID , data).then((response) => {
          console.log('add response:', response);


          let EditData = {
            YarnType: args.data.YarnType,
            YarnTypeShort: args.data.YarnTypeShort
          }
          let totalColumns = Object.keys(EditData);
          console.log(totalColumns)

          AuditTableInput.auditEdit(totalColumns,selectedRows,EditData,`YarnType`,args.data.YarnTypeID)
          getYarnTypes();
          //setYarnTypes(response.data.recordset);
          // refresh grid to show new record
          // const type = getRoute()[1];
          // getYarnTypes(type);

        });
      }

    }

  };

  // const actionComplete = (args: DialogEditEventArgs) => {
  //   console.log('data: ', args);
  //   if (args.form) {
  //     console.log('data: ', args);
  //     if (args.requestType === 'beginEdit' || args.requestType === 'add') {
  //       console.log('e: ', args.form.ej2_instances[0]);
  //       /** Add Validation Rules */
  //       args.form.ej2_instances[0].addRules('YarnType', { required: true });
  //       args.form.ej2_instances[0].addRules('YarnTypeShort', {required: true,});


  //         console.log('response: ', response);
  //                             // refresh grid to show new record
  //                             const type = getRoute()[1];
  //                             getYarnTypes(type);
  //       });
  //     }

  //   }

  // };

  // const commandClick = (args: CommandClickEventArgs) => {
  //   setShowDialog(false);
  //   console.log('command click args: ', args);
  //   setSelectedRow(args.rowData);
  //   setShowDialog(true);
  // };

  // const commands: CommandModel[] = [
  //   {
  //     buttonOption: {
  //       content: 'Delivery Schedule',
  //       cssClass: 'e-flat',
  //     },
  //   },
  // ];

  // const dialogClose = () => {
  //   this.buttonInstance.style.display = 'inline-block';
  //   setShowDialog(false);
  // };

  // const openDialog = () => {
  //   setShowDialog(true);
  // }; 

  const DELETE_MESSAGE = "DELETED SUCCESSFULLY";
  const CONFLICT_MESSAGE = "CONFLICT IN DATABASE";
  const deleteRow = () => {
    YarnTypeService.delete(deletingID)
      .then((response) => {
        console.log(response);
        setWarningMessage(DELETE_MESSAGE);
        warningDialog.current.show();
      })
      .catch((e) => {
        setWarningMessage(CONFLICT_MESSAGE);
        warningDialog.current.show();
      });
  };

  const deleteButtons = [
    {
      buttonModel: {
        content: "OK",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: (e) => {
        deleteDialog.current.hide();
        console.log(e);
        deleteRow();
      },
    },
    {
      buttonModel: {
        content: "Cancel",
        cssClass: "e-flat",
      },
      click: () => {
        deleteDialog.current.hide();
      },
    },
  ];

  const warningButtons = [
    {
      buttonModel: {
        content: "OK",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => {
        warningDialog.current.hide();
        // setTimeout(() => {
        //   if (!(warningMessage.includes('access denied'))) {
        //     // record was succesfully deleted
        //     const type = getRoute()[1];
        //     getYarnContracts(type);
        //     // console.log("record was succesfully deleted");
        //   }
        // }, 500);
      },
    },
  ];

  function deleteDialogClose() {
    setDeleteDialogVisibility(false);
  }

  function warningDialogClose() {
    setDialogWarningVisibility(false);
    if (warningMessage.includes(DELETE_MESSAGE)) {
      getYarnTypes();
    }
  }

  const DeleteDialogComponent = () => (
    <div>
      <DialogComponent
        ref={deleteDialog}
        width={500}
        visible={deleteDialogVisibility}
        close={deleteDialogClose}
        content={() => <div>Are you sure you want to delete?</div>}
        isModal={true}
        header="Confirmation"
        buttons={deleteButtons}
      // footerTemplate={footerTemplate}
      />
      <DialogComponent
        ref={warningDialog}
        width={400}
        visible={dialogWarningVisibility}
        close={warningDialogClose}
        content={() => <div>{warningMessage}</div>}
        isModal={true}
        header="Warning"
        buttons={warningButtons}
      // footerTemplate={footerTemplate}
      />
    </div>
  );

  const YarnTypeGridComponent = useMemo(() => ({ restrictPageSize = 12 }) => (
    <GridComponent
    ref={(grid) => (yarnTypesGrid = grid)}
    id='yarnTypesGrid'
    dataSource={yarnTypes}
    editSettings={editSettings}
    toolbar={toolbarOptions}
    pageSettings={{ pageCount: 4, pageSizes: true, pageSize: restrictPageSize }}
    filterSettings={filterOptions}
    groupSettings={groupOptions}
    actionComplete={actionComplete}
    allowTextWrap='true'
    // commandClick={commandClick}

    allowPaging={true}
    allowSorting={true}
    allowPdfExport={true}
    allowExcelExport={true}
    toolbarClick={toolbarClick}
    allowFiltering={true}
    allowGrouping={true}
    showColumnChooser={true}
    allowReordering={true}
    allowResizing={true}
    sortSettings={sortingOptions}
   dataBound={databound}

     rowSelected={
      (args)=>{
        console.log(args.data)
        selectedRows = args.data
        
                  setTimeout(() => {
          console.log('ss')
        }, 200);
      }
    }

    >
      <ColumnsDirective>
        {/* <ColumnDirective
                headerText='Commands'
                width='170'
                commands={commands}
                textAlign='Left'
              /> */}

        {/* <ColumnDirective
                headerText='Full Yarn Count'
                field='YarnType'
                width='130'
                textAlign='Left'
              /> */}
        {/* <ColumnDirective
                headerText='Order Date'
                field='OrderDate'
                width='200'
                
                type='date'
                format='dd/MM/yy'
              /> */}
       <ColumnDirective
          headerText='ID'
          field='YarnTypeID'
          width='200'
          headerTextAlign='Center'
          textAlign='Right'
        />
        <ColumnDirective
          headerText='Yarn Type'
          field='YarnType'
          width='200'
          headerTextAlign='Center'
          textAlign='Left'
        />
        <ColumnDirective
          headerText='Yarn Type Short'
          field='YarnTypeShort'
          width='200'
          headerTextAlign='Center'
          textAlign='Left'
        />
        {/* <ColumnDirective
          headerText='Cancel'
          field='IsDeleted'
          width='200'
          headerTextAlign='Center'
          textAlign='Left'
          visible={false}
        /> */}
        {/* <ColumnDirective
                headerText='Bags Ordered'
                field='OrderBags'
                width='150'
              />
              <ColumnDirective
                headerText='Bags Weight'
                field='WeightPerBag'
                width='150'
              />
              <ColumnDirective
                headerText='Procurement Type'
                field='ProcurementType'
                width='150'
              />
              <ColumnDirective
                headerText='Start Date'
                field='ContractStartDate'
                width='150'
                type='date'
              />
              <ColumnDirective
                headerText='End Date'
                field='ContractEndDate'
                width='150'
                type='date'
              />
              <ColumnDirective
                headerText='Currency'
                field='CurrencyName'
                width='140'
              />
              <ColumnDirective
                headerText='Foreign Currency Rate'
                field='ForeignCurrencyRate'
                width='200'
              />
              <ColumnDirective
                headerText='Foreign Currency Amount'
                field='ForeignCurrencyAmount'
                width='200'
              />
              <ColumnDirective
                headerText='Contract Exchange Rate'
                field='ContractExchangeRate'
                width='200'
              />
              <ColumnDirective
                headerText='Bags Received'
                field='ReceivedBags'
                width='140'
              />
              <ColumnDirective
                headerText='Bags Returned'
                field='ReturnedBags'
                width='140'
              />
              <ColumnDirective
                headerText='Tax %'
                field='TaxPercent'
                width='100'
              />
              <ColumnDirective
                headerText='Tax Type'
                field='TaxType'
                width='150'
              /> */}
      </ColumnsDirective>

      {/* <AggregatesDirective>
              <AggregateDirective>
                <AggregateColumnsDirective>
                  <AggregateColumnDirective
                    field='OrderBags'
                    type='Sum'
                    footerTemplate={footerSum}
                  />
                </AggregateColumnsDirective>
              </AggregateDirective>
              <AggregateDirective>
                <AggregateColumnsDirective>
                  <AggregateColumnDirective
                    field='OrderBags'
                    type='Sum'
                    groupFooterTemplate={footerSum}
                  />
                </AggregateColumnsDirective>
              </AggregateDirective>
            </AggregatesDirective> */}

      <Inject
        services={[
          Edit,
          Toolbar,
          Page,
          Sort,
          PdfExport,
          ExcelExport,
          Filter,
          Group,
          Aggregate,
          Freeze,
          ColumnChooser,
          Reorder,
          Resize,
          // CommandColumn,
        ]}
      />
    </GridComponent>
  ), [yarnTypes]);

  const userId = SecurityService.getLoggedInUserId();

  return (
    (props.isDialog) ? (
      <div>
        <DeleteDialogComponent />
        <YarnTypeGridComponent restrictPageSize={5} />
      </div>
    ) :
      (
        <div className="content-wrapper">
          <div>
            
          {showDialogs ?
          <HardDelete
            {...deletingProps} 
            showResult={(e)=>{
                                console.log(e)

                                setShowDialogs(false)
                                if(e == false){
                                  setShowDialogs(false)
                                  // setProcessingDetails(
                                  //   processingDetails.filter(
                                  //     (item) => item?.FabricProcessingContractDetailID !== deletingID
                                  //   )
                                  // );

                                  //  fabricProcessingContractGrid.dataSource[args?.rowIndex] =   args?.data;
        // console.log("save: ", data);
        // FabricProcessingContractService.create(data);
        setTimeout(() => {
          
          // yarnCountGrid.refresh()
          getYarnTypes();

        }, 200);
      // getProductCutSize(props.path.substring(1));

                                  // const type = getRoute()[1];
                                  // getProcessDesc(type);
                                }
              }} 
                ></HardDelete>
                  :null}

            <div>
              <h3>Yarn Type - List</h3>
              <DeleteDialogComponent />
              <div>
                {/* <ButtonComponent onClick={addYarnContract}>Add </ButtonComponent> */}
                {/* <button
                  className='m-3 btn btn-sm btn-primary'
                  onClick={this.addYarnContract}
                >
                  Add
                </button> */}
              </div>
              {/* <div>
                <ReactDataGrid columns={columns} rows={rows} editor={true} />
              </div> */}

              {/* <div className='e-statustext'>
                    Select column name to toggle visibility
                  </div> */}
              {/* <ToolbarComponent
                    id='toolbar'
                    ref={(toolbar) => (this.ToolbarInstance = toolbar)}
                    onClick={toolBarClick(this)}
                  >
                    <ItemsDirective>
                      <ItemDirective text='Order ID' />
                      <ItemDirective text='Customer Name' />
                      <ItemDirective text='Freight' />
                      <ItemDirective text='Order Date' />
                      <ItemDirective text='Shipped Date' />
                      <ItemDirective text='Ship Country' />
                    </ItemsDirective>
                  </ToolbarComponent> */}
              {/* <div className='App' id='dialog-target'>
              <DialogComponent
                width='600px'
                target='#dialog-target'
                visible={showDialog}
                close={dialogClose}
                content={contentTemplate}
                isModal={true}
                showCloseIcon={true}
                header={header}
                
              />
            </div> */}

              <YarnTypeGridComponent />
            </div>
          </div>
        </div>
      )
  );
}

